

const formatDate = (date = new Date()) => {
    if (date !== null){
    return [
      `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`
    ]
    }else {
        return null;
    }

  }

  export default formatDate;